// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chart-radar "},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12.0002 2L22.0102 9.27269L18.1868 21.0402H5.81371L1.99023 9.27269L12.0002 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12.0002 2L22.0102 9.27269M12.0002 2L1.99023 9.27269M12.0002 2L12 12.5251M22.0102 9.27269L18.1868 21.0402M22.0102 9.27269L12 12.5251M18.1868 21.0402H5.81371M18.1868 21.0402L12 12.5251M5.81371 21.0402L1.99023 9.27269M5.81371 21.0402L12 12.5251M1.99023 9.27269L12 12.5251","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chart-radar')
export default class ChartRadarIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-radar',
    }
  }
}
